import React from 'react';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Interstitial from './index';

const PatientEnrollModal = ({ trigger, linkTo }) => {
  const content = (
    <div>
      <h3>Ready to enroll?</h3>
      <p>Make sure you have the following nearby:</p>
      <ul>
        <li><img src="/images/checkmark_icon.png" alt="Red checkmark" /><span>Your driver’s license</span></li>
        <li><img src="/images/checkmark_icon.png" alt="Red checkmark" /><span>Your insurance card</span></li>
        <li><img src="/images/checkmark_icon.png" alt="Red checkmark" /><span>Your doctor’s name and office address</span></li>
      </ul>
      <Button as={ Link } to={ linkTo }>Continue</Button>
    </div>
  );

  return (
    <Interstitial
      main_content={ content }
      class="patient-enroll-modal"
      trigger={ trigger }
    />
  );
};

export default PatientEnrollModal;
